/**
 * Footer component
 * Site-wide footer with contact information and copyright
 */
const Footer: React.FC = () => {
  return (
    <footer className='footer'>
      <div className='contact-info'>
        <p>Email: ramirez-rentals@gmail.com</p>
        <p>Phone: 555-555-5555</p>
      </div>
      <p className='copyright'>
        Copyright &copy; Ramirez Rentals {new Date().getFullYear()}. All rights reserved
      </p>
    </footer>
  );
};

export default Footer;
